import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/deposito';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageValidacoes() {
  return (
    <Root title={PAGE_TITLE.VALIDACOES}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
